// extracted by mini-css-extract-plugin
export var active = "_l7-e";
export var blink = "_l7-f";
export var dropDownSelector = "_l7-5";
export var dropDownWrapper = "_l7-4";
export var fakeCursor = "_l7-d";
export var fontSizeButton = "_l7-7";
export var formQuillEditor = "_l7-0";
export var pressed = "_l7-g";
export var qlBlank = "_l7-1";
export var textFormattingToolbar = "_l7-2";
export var textFormattingToolbarClosed = "_l7-3";
export var textFormattingToolbarInline = "_l7-6";
export var textToolbarOption = "_l7-8";
export var toolbarCell = "_l7-a";
export var toolbarCellCollapsed = "_l7-b";
export var toolbarOptionHitArea = "_l7-c";
export var toolbarOverflow = "_l7-9";